// removed by extract-text-webpack-plugin
module.exports = {"container":"Icon-container","rotate90":"Icon-rotate90","rotate180":"Icon-rotate180","rotate270":"Icon-rotate270"};